/** @jsx jsx */
import { jsx, Flex, Box } from "theme-ui"
import Squiggle from "components/svgs/squiggle"
import PropTypes from "prop-types"

const Sideline = ({ side, children, sx }, props) => (
  <Flex
    {...props}
    sx={{
      alignItems: "center",
      my: 3,
      position: "relative",
      ...sx,
    }}
  >
    <Squiggle
      sx={{
        bottom: 0,
        height: ["9rem", "auto"],
        order: side === "left" ? 1 : 2,
        mr: side === "left" ? 3 : 0,
        ml: side === "right" ? 3 : 0,
        minWidth: ["none", "3rem"],
        top: 0,
        left: 0,
        display: "inline-block",
      }}
    />
    <Box sx={{ order: side === "right" ? 1 : 2 }}>{children}</Box>
  </Flex>
)

Sideline.defaultProps = {
  side: "left",
}

Sideline.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.any,
  side: PropTypes.string,
}

export default Sideline
